import { useTheme } from '@mui/material/styles';
import React from 'react';

const Svg2 = () => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path
        fill={theme.palette.alternate.main === '#1a2138' ? '#ffd' : '#4e9171'}
        fillOpacity={0.9}
        d="M0,224L30,213.3C60,203,120,181,180,186.7C240,192,300,224,360,202.7C420,181,480,107,540,96C600,85,660,139,720,133.3C780,128,840,64,900,58.7C960,53,1020,107,1080,128C1140,149,1200,139,1260,112C1320,85,1380,43,1410,21.3L1440,0L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"
      ></path>
    </svg>
  );
};

export default Svg2;
